import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getHoje(): string {
  return new Date().toISOString().split('T')[0];
}

export function isDiaUtil(data: Date): boolean {
  const diaDaSemana = data.getDay();
  return diaDaSemana !== 0 && diaDaSemana !== 6;
}

export function formatarDataISO(data: string | Date): string {
  if (!data) return ""; // evita undefined ou null

  const dataObj = typeof data === "string" ? new Date(data) : data;

  if (isNaN(dataObj.getTime())) {
    console.warn("⚠️ Data inválida recebida em formatarDataISO:", data);
    return ""; // ou alguma fallback, tipo getHoje()
  }

  return dataObj.toISOString().split("T")[0];
}


